export default __webpack_public_path__ + "static/2.5.1/media/contactImage.e15dd3a5.svg";